<!--
 * @Author: 田鑫
 * @Date: 2022-01-06 10:27:52
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-13 21:16:59
 * @Description: 厨师管理
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>厨师管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="厨师名称：" prop="cookName">
          <el-input style="width: 300px" v-model="listParams.cookName" placeholder="请填写厨师名称"></el-input>
        </el-form-item>
        <el-form-item label="餐厅名称：" prop="canteenName">
          <el-input style="width: 300px" v-model="listParams.canteenName" placeholder="请填写餐厅名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog('')" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="厨师名称" prop="cookName" align="center"></el-table-column>
          <el-table-column label="所属餐厅" prop="canteenName" align="center"></el-table-column>
          <el-table-column label="擅长类型" prop="cuisineType" align="center"></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该厨师吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item label="厨师名称：" prop="cookName">
          <el-input v-model="dialogForm.cookName" placeholder="请填写厨师名称，如有评级，可在名称后输入等级，如：一级厨师" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="厨师头像：" prop="avatar">
          <oss-uploader @setImage="getImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-radio v-model="dialogForm.sex" label="男"></el-radio>
          <el-radio v-model="dialogForm.sex" label="女"></el-radio>
        </el-form-item>
        <el-form-item label="所属餐厅：" prop="canteenId">
          <el-select v-model="dialogForm.canteenId" placeholder="请选择所属餐厅" style="width: 100%">
            <el-option v-for="(item, index) in restaurantList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="擅长类型：" prop="cuisineType">
          <el-input v-model="dialogForm.cuisineType" placeholder="如：川菜、鲁菜、淮扬菜" maxlength="15" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="mobile">
          <el-input v-model="dialogForm.mobile" placeholder="请填写联系人电话用于短信通知" maxlength="11" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="简介：" prop="cookDescription">
          <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="dialogForm.cookDescription" />
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const checkMobileRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写餐厅联系电话"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("电话格式不正确，请重新填写"));
      } else {
        callback();
      }
    };
    return {
      listParams: {
        cookName: "",
        canteenName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      restaurantList: [],
      dialogVisible: false,
      dialogForm: {
        cookName: "",
        avatar: "",
        sex: "",
        canteenId: "",
        cuisineType: "",
        mobile: "",
        cookDescription: "",
      },
      dialogRules: {
        cookName: [{ required: true, message: "请填写厨师名称", trigger: "blur" }],
        sex: [{ required: true, message: "请选择厨师性别", trigger: "change" }],
        canteenId: [{ required: true, message: "请选择所属餐厅", trigger: "change" }],
        cuisineType: [{ required: true, message: "请选择擅长类型", trigger: "change" }],
        mobile: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
          { validator: checkMobileRule, trigger: "blur" },
        ],
        cookDescription: [{ required: true, message: "请填写厨师简介", trigger: "blur" }],
      },
      isDisabled: false,
      previewList: [],
      method: "",
      url: "",
    };
  },

  mounted() {
    this.loadTableData();
    this.loadRestaurantList();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/cook/cookList",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    loadRestaurantList() {
      this.$http({
        url: global.apiUrl + "/canteen",
        method: "GET",
        params: {
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.restaurantList = res.body.data.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑厨师
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + "/cook/cookDetail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            if (this.dialogForm.sex === 0) {
              this.dialogForm.sex = "男";
            } else {
              this.dialogForm.sex = "女";
            }
            if (this.dialogForm.avatar) {
              console.log("avatar", this.dialogForm.avatar);
              this.previewList = [this.dialogForm.avatar];
            }
            this.openDialog(id);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除厨师
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/cook/deleteCook",
        method: "DELETE",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    openDialog(id) {
      if (id) {
        this.method = "PUT";
        this.url = "/cook/editCook";
      } else {
        //* 还原表单
        this.dialogForm = this.$options.data().dialogForm;
        this.previewList = [];
        this.method = "POST";
        this.url = "/cook/addCook";
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 获取图片
     * @param {*} file
     * @return {*}
     */
    getImage(value) {
      if (value) {
        this.dialogForm.avatar = value;
        this.previewList = [this.dialogForm.avatar];
      } else {
        this.dialogForm.avatar = "";
        this.previewList = [];
      }
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = JSON.parse(JSON.stringify(Object.assign(this.dialogForm)));
          if (bodyParams.sex === "男") {
            bodyParams.sex = 0;
          } else {
            bodyParams.sex = 1;
          }
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                //* 还原表单
                this.dialogForm = this.$options.data().dialogForm;
                this.previewList = [];
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  margin-bottom: 10px;
}
</style>
